import React, { useEffect, useState } from "react";

export default function AvailabilityRow({
  day,
  availability,
  setAvailability,
  readOnly = false,
}) {
  const isWeekend = day === "Saturday" || day === "Sunday";
  const [collapsed, setCollapsed] = useState(false);

  // Filter availability based on day
  const slots = availability.filter((slot) => slot.day === day);

  useEffect(() => {
    // Default slot creation logic
    if (!isWeekend && slots.length === 0 && !readOnly) {
      setAvailability((prev) => [
        ...prev,
        { day, start: "09:00", end: "17:00", enabled: true },
      ]);
    }
  }, [slots, day, readOnly]);

  const addSlot = () => {
    if (!readOnly) {
      setAvailability((prev) => [
        ...prev,
        { day, start: "09:00", end: "17:00", enabled: true },
      ]);
    }
  };

  const updateSlot = (index, field, value) => {
    if (readOnly) return;

    const updated = [...availability];
    const daySlots = updated.filter((s) => s.day === day);
    const globalIndex = updated.findIndex((s) => s === daySlots[index]);

    if (globalIndex !== -1) {
      updated[globalIndex] = {
        ...updated[globalIndex],
        [field]: value,
      };
      setAvailability(updated);
    }
  };

  const removeSlot = (index) => {
    if (readOnly) return;

    const daySlots = availability.filter((s) => s.day === day);
    const slotToRemove = daySlots[index];
    const globalIndex = availability.findIndex((s) => s === slotToRemove);

    if (globalIndex !== -1) {
      const updated = [...availability];
      updated.splice(globalIndex, 1);
      setAvailability(updated);
    }
  };

  const clearAllSlots = () => {
    if (readOnly) return;

    const updated = availability.filter((slot) => slot.day !== day);
    setAvailability(updated);
  };

  // Total hours calculation function (fixed)
  const getTotalHours = () => {
    let totalMinutes = 0;

    // Ensure we only calculate hours for enabled slots
    slots.forEach((slot) => {
      if (!slot.enabled) return;  // Only calculate for enabled slots

      const [startH, startM] = slot.start.split(":").map(Number);
      const [endH, endM] = slot.end.split(":").map(Number);

      const start = startH * 60 + startM;
      const end = endH * 60 + endM;

      totalMinutes += Math.max(end - start, 0); // Avoid negative minutes
    });

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  };

  const isDisabled = isWeekend && slots.length === 0;

  return (
   <div className="row">
     <div className="col-md-12 col-12">
      <div className={`mb-4 border rounded ${isDisabled ? "bg-light text-muted" : ""}`}>
        <div className="row d-flex  justify-content-between align-items-center mb-2">
          <div className="col">
            <div className="d-flex tetbx justify-content-between align-items-center">
            <div className="fw-bold">{day}</div>
            <div>
              {slots.length > 0 && !readOnly && (
                <button
                  className="btn btn-sm btn-outline-danger me-2"
                  onClick={clearAllSlots}
                >
                  Clear All
                </button>
              )}
              {!readOnly && (
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setCollapsed(!collapsed)}
                >
                  {collapsed ? "Expand" : "Collapse"}
                  <i className={`bi ms-1 ${collapsed ? "bi-chevron-down" : "bi-chevron-up"}`}></i>
                </button>
              )}
            </div>
          </div>
          </div>
        </div>
     <div className=" p-3 ">
      {!collapsed && (
        <>
          {slots.map((slot, index) => (
            <div key={index} className="d-flex gap-3 align-items-center mb-2">
              <div className="">
                <input
                  type="time"
                  className="form-control"
                  value={slot.start}
                  disabled={readOnly || !slot.enabled}
                  onChange={(e) => updateSlot(index, "start", e.target.value)}
                />
              </div>
              <div className=" text-center">to</div>
              <div className="">
                <input
                  type="time"
                  className="form-control"
                  value={slot.end}
                  disabled={readOnly || !slot.enabled}
                  onChange={(e) => updateSlot(index, "end", e.target.value)}
                />
              </div>
              <div className="">
                {!readOnly && (
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={slot.enabled}
                      onChange={(e) =>
                        updateSlot(index, "enabled", e.target.checked)
                      }
                    />
                    <label className="form-check-label">Enabled</label>
                  </div>
                )}
              </div>
              <div className="">
                {slots.length > 1 && !readOnly && (
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => removeSlot(index)}
                  >
                    <i class="bi bi-trash-fill"></i>
                  </button>
                )}
              </div>
            </div>
          ))}
        
          <div className="mb-2">
            <strong>Total Available:</strong> {getTotalHours()}
          </div>
        
          {!readOnly && (
            <button
              className="btn btn-sm btn-outline-success"
              onClick={addSlot}
            >
              + Add
            </button>
          )}
        </>
      )}
      </div>
    </div>
    </div>
   </div>
  );
}
